<template>
  <div class="member-list">
    <div class="title bold">Members ({{ members.length }})</div>
    <div
      style="display: inline-block"
      :class="{ 'icon-rotated': membersListCollapsed }"
    >
      <span class="icon-arrow-collapse" v-on:click="collapseMembersList" />
    </div>
    <div
      class="member-list-container"
      :class="{
        collapsed: membersListCollapsed,
        'show-less-members': showLessMembers,
      }"
    >
      <div
        class="member-row"
        v-for="memberName in membersNamesToShow"
        :key="memberName.id"
      >
        <div class="member">
          <span class="member-circle">{{
            memberName.name[0].toUpperCase()
          }}</span>
          <span class="member-name">{{ memberName.name }}</span>
        </div>
        <span
          v-if="isOwner"
          class="black primary-color"
          @click="act(memberName.id)"
          >Remove</span
        >
      </div>
    </div>
    <div
      v-if="longMemberList && !membersListCollapsed"
      class="expand-text bold"
    >
      <div v-if="showLessMembers == false" @click="showLessMembers = true">
        See less
      </div>
      <div v-if="showLessMembers == true" @click="showLessMembers = false">
        See more
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      membersListCollapsed: false,
      showLessMembers: true,
    };
  },
  computed: {
    membersNamesToShow() {
      let membersNamesNew = JSON.parse(JSON.stringify(this.members));
      for (let i in membersNamesNew) {
        if (membersNamesNew[i].surname) {
          membersNamesNew[i].name =
            membersNamesNew[i].name + " " + membersNamesNew[i].surname;
        }
      }
      return membersNamesNew;
    },
    longMemberList() {
      return this.membersNamesToShow.length > 5;
    },
  },
  props: {
    act: {
      type: Function,
      required: true,
    },
    members: {
      type: Array,
      reqired: true,
    },
    isOwner: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    collapseMembersList: function () {
      this.membersListCollapsed = !this.membersListCollapsed;
      this.showLessMembers = true;
    },
  },
};
</script>


<style scoped lang="scss">
@use '@/styles/theme.scss';

.member-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0px;
  border-bottom: 1px solid theme.$light-grey-background;
}

.member-row .member span {
  display: inline-block;
  vertical-align: middle;
}

.member-row .member-circle {
  background: theme.$secondary-color;
  color: theme.$text-color;
  font-size: 12px;
  height: 25px;
  width: 25px;
  line-height: 25px;
  text-align: center;
  vertical-align: 10px;
  border-radius: 50%;
  margin-right: 8px;
}

.title {
  display: inline-block;
  margin-bottom: 8px;
}

span.icon-close {
  cursor: pointer;
  font-size: 24px;
  position: absolute;
  top: 30px;
  right: 30px;
}

span.icon-arrow-collapse {
  font-size: 24px;
  vertical-align: sub;
}

.icon-rotated {
  transform: rotate(-90deg);
}

.collapsed {
  display: none;
  overflow: hidden;
}

.expand-text {
  margin-top: 4px;
  font-size: 14px;
  text-align: center;
  color: theme.$text-secondary-color;
  border-radius: 5px;
  width: 80px;
  height: 30px;
  line-height: 30px;
}

.expand-text:hover {
  background-color: theme.$light-grey-background;
}

.show-less-members {
  overflow: hidden;
  max-height: 16.5em;
}

span.primary-color {
  margin-right: 4px;
  border-radius: theme.$button-border-radius;
  padding: 6px 8px;
}

span.primary-color:hover {
  background-color: theme.$secondary-color;
}

span.member-name {
  color: theme.$text-secondary-color;
  padding: 6px 0px;
}
</style>